import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import SkeletonLoading from 'helpers/loading/skeletonLoading';

const Component = lazy(() => import('components/integration-external-machines'));

const IntegrationExternalMachines = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<SkeletonLoading rows={8} />}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default IntegrationExternalMachines;
